// extracted by mini-css-extract-plugin
export default {"preview":"BagelSmsConsentInfo_preview__muO18","fieldLabel":"BagelSmsConsentInfo_fieldLabel__eijsU","consentRow":"BagelSmsConsentInfo_consentRow__MPBm9"};